/**
 * Contains the URLs for third-party APIs used in the application.
 */
export class ThirdPartyApisUrls {

    /*
    API URL for nomating.org
     */
    public static readonly NOMINATIM = 'https://nominatim.openstreetmap.org/reverse';
}